import {IReportService} from "./report_service";

export class StubReportService implements IReportService {
    public static $inject = ['$q'];

    constructor(protected $q : ng.IQService) {

    }

    createReport(subject: any, reportTemplateId: string, title: string, topicName?: string): ng.IPromise<object> {
        return this.$q.reject('not implemented');
    }

    createReportForName(subject: any, reportName: string, title: string, topicName?: string): ng.IPromise<object> {
        return this.$q.reject('not implemented');
    }

    getReport(id: string): ng.IPromise<object> {
        return this.$q.reject('not implemented');
    }

    reportTemplateByName(name: string): ng.IPromise<object> {
        return this.$q.reject('not implemented');
    }

    deleteReport(report: any): ng.IPromise<any> {
        return this.$q.reject('not implemented');
    }

    reportsForUserFeatureId(id: string | number): object[] {
        return [];
    }

    updateReport(report: any) {
    }
}